import React from 'react';

import {observer} from 'mobx-react';
import {AppModuleProps} from "../models/app-module.props";
import {APP} from "../consts";
import {WebsiteModuleAsync} from "../../../apps/website/components/website.module.async";

export class AppModuleContentWebsiteComponentProps extends AppModuleProps {
}

export const AppModuleContentWebsite = observer(({controller}: AppModuleContentWebsiteComponentProps) => {
  const {state} = controller;

  const websiteProps = {
    params: state.settings,
    basename: state.basename,
    pushNotificationRequestPermission: (trigger) => controller.action(APP.ACTION_TYPES.pushNotificationsUserSelection, {trigger: trigger}),
  }

  return (
    <WebsiteModuleAsync {...websiteProps} />
  )
})
